import api from '@/api/api'
import dayjs from 'dayjs'

const state = {
  comments: [],
  subComments: [],
  inputType: 0
}

const mutations = {
  setComments: (state, comments) => {
    state.comments = comments
  },
  setSubComments: (state, comments) => {
    state.subComments = comments
  },

  deleteComment: (state, commentId) => {
    const comments = state.comments.filter(item => {
      return item.id !== commentId
    })
    state.comments = comments
  },

  deleteSubComment: (state, commentId) => {
    const comments = state.subComments.filter(item => {
      return item.id !== commentId
    })
    state.subComments = comments
  },

  setInputType: (state, type) => {
    state.inputType = type
  }
}

const actions = {
  commitComment({ commit }, params) {
    console.log('=====commit comment', commit)
    return api.comment.commitComment(params).then(res => {
      return res.result
    })
  },

  getComments({ commit }, params) {
    params = {
      ...params,
      pageSize: 1000
    }

    return api.comment.getComments(params).then(res => {
      commit('setComments', parseComments(res.detail.list))
      return res
    })
  },

  getCommentList({ commit }, params) {
    params = {
      ...params,
      pageSize: 1000
    }

    return api.comment.getCommentList(params).then(res => {
      commit('setComments', parseComments(res.detail.list))
      return res
    })
  },

  getSubComments({ commit }, params) {
    params = {
      ...params,
      pageSize: 1000
    }

    return api.comment.getSubComments(params).then(res => {
      commit('setSubComments', parseComments(res.detail.list))
    })
  },

  deleteComment({ commit }, commentId) {
    console.log('=====delete comment', commit)
    return api.comment.deleteComment(commentId).then(res => {
      return res.result
    })
  },
  getLiveComments({ commit }, params) {
    console.log('=====getLiveComments comment', commit)
    return api.comment.getLiveComments(params).then(res => {
      return res
    })
  },
  commitLiveComment({ commit }, params) {
    console.log('=====commit comment', commit)
    return api.comment.commitLiveComment(params).then(res => {
      return res.result
    })
  }
}

const parseComments = items => {
  if (items == undefined || items.length == 0) {
    return []
  }
  console.log('=======comments', items)
  return items.map(item => {
    item.createTime = dayjs(item.createTime).format('MM-DD HH:mm')
    return item
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
